import {Button, ColourSolid, Modal, ModalType, ToggleSwitch, ToggleType} from "@twigsby/frontend-framework";
import React, {useState} from "react";
import {useTranslation} from "@twigsby/frontend-framework";
import {useMailbox} from "../../../Providers/NewMailboxProvider";

interface DeleteCustomFolderModalType extends ModalType {

}

const DeleteCustomFolderModal = (props: DeleteCustomFolderModalType) => {
    const { t } = useTranslation();
    const { activeCustomFolderData, DeleteCustomFolder, ToggleDeleteCustomFolderModal, deleteCustomFolderOpen } = useMailbox();
    const [ deleteChildFolders, setDeleteChildFolders] = useState<boolean>(false);

    return (
        <Modal title={t('customFolders.deleteFolder.title', { folder: activeCustomFolderData?.description})} isOpen={deleteCustomFolderOpen} closeCallback={() => ToggleDeleteCustomFolderModal(false)}>
            <p>{t('customFolders.deleteFolder.description')}</p>
            {activeCustomFolderData?.childFolders && (
                <ToggleSwitch extraClass={'mb-lg'} name={'DeleteChildFolders'} label={t('customFolders.deleteFolder.labels.deleteChild')} type={ToggleType.Checkbox} defaultChecked={deleteChildFolders} onChange={() => setDeleteChildFolders(!deleteChildFolders)} />
            )}
            <Button title={t('customFolders.deleteFolder.actions.deleteFolder')} fullWidth={true} onClick={() => DeleteCustomFolder(deleteChildFolders) } colour={ColourSolid.Primary} />
        </Modal>
    )
}

export { DeleteCustomFolderModal }
